import * as React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/joy/Tooltip';
import { Zoom } from '@mui/material';

// FontAwesome icon
import { InfoIcon } from '../../icons/FontAwesomeIcon';

const Tooltips = React.memo(function Tooltips({ tooltipText = 'Add Tooltip Text Here' }) {
    return (
        <Tooltip
            title={tooltipText}
            placement="right"
            color="neutral"
            arrow
            variant="soft"
            slots={{
                transition: Zoom
            }}
        >
            <IconButton
                sx={{
                    color: '#f5f5f5',
                    fontSize: '1.25rem'
                }}
            >
                <InfoIcon />
            </IconButton>
        </Tooltip>
    );
});

Tooltips.propTypes = {
    tooltipText: PropTypes.string
};

export default Tooltips;
